import 'kendo.localization';
import 'kendo.messages';
import Enum from 'enum';
import HashMap from 'hashmap';
import * as _ from 'lodash';

import { appContext } from 'common/RFR';


HashMap.prototype.computeIfAbsent = function computeIfAbsent(key, mappingFunction) {
  const oldValue = this.get(key);
  if (_.isNil(oldValue)) {
    const newValue = mappingFunction.call(this, key);
    if (!_.isNil(newValue)) {
      this.set(key, newValue);
      return newValue;
    }
  }

  return oldValue;
};

HashMap.prototype.computeIfPresent = function computeIfPresent(key, remappingFunction) {
  const oldValue = this.get(key);
  if (_.isNil(oldValue)) {
    return null;
  }

  const newValue = remappingFunction.call(this, key, oldValue);
  if (!_.isNil(newValue)) {
    this.set(key, newValue);
  } else {
    this.remove(key);
  }
  return newValue;
};

HashMap.prototype.compute = function computeIfPresent(key, remappingFunction) {
  const oldValue = this.get(key);

  const newValue = remappingFunction.call(this, key, oldValue);
  if (_.isNil(newValue)) {
    if (!_.isNil(oldValue) || this.containsKey(key)) {
      this.remove(key);
    }
    return null;
  }

  // добавление/замена старого значения
  this.set(key, newValue);
  return newValue;
};

HashMap.prototype.isEmpty = function isEmpty() {
  return (this.count() === 0);
};

/**
 * @param mappingFunction функция маппинга, что внезапно: (value -> key), потому что: смотри forEach()
 * @return {Array}
 */
HashMap.prototype.map = function map(mappingFunction) {
  const result = [];
  this.forEach((value, key) => {
    result.push(mappingFunction.call(this, value, key));
  });
  return result;
};


// --- Всякие глобальные штуки, специфичные для фреймворков ---
Enum.prototype.kendoValues = function kendoValues() {
  return Object.keys(this._enumMap).reduce((all, key) => {
    all.push({
      value: key,
      text: this._enumMap[key],
    });

    return all;
  }, []);
};

// Удобное форматирование строк в виде "{0} abcd {1} efg".format(x, y);
if (!String.prototype.format) {
  String.prototype.format = function format(...args) { // eslint-disable-line
    return this.replace(/{(\d+)}/g, (match, number) => (typeof args[number] !== 'undefined' ? args[number]
      : match));
  };
}

// Включаем русскую локализацию Kendo
kendo.culture('ru-RU');

const IS_ADMIN = /^\/admin/.test(window.location.pathname);
appContext.application = IS_ADMIN ? 'admin' : 'user';

if (IS_ADMIN) {
  import('passport/backoffice');
} else {
  import('passport/frontoffice');
}



// WEBPACK FOOTER //
// ./src/main.js